/** @desc Util class for generate functions **/
export class GenerateService {
  /**
   * Util function to generate a new search url
   * @param {object} filter - Object with filtervalues
   * @return {string} The new search url
   */
  generateSearchUrl(filter: object): string {
    let hasParam = false,
      url = '',
      param = '',
      prop;
    if (!filter) {
      return url;
    }
    for (prop in filter) {
      if (filter.hasOwnProperty(prop) && filter[prop]) {
        if (!hasParam) {
          hasParam = true;
          url += '?';
        }
        if (param) {
          url += '&';
          param = '';
        }
        param += prop;
        param += '=';
        param += encodeURIComponent(filter[prop]);
        url += param;
      }
    }
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/util/generate.service.ts